<template>
  <div v-if="show" style="width: 100%; height: 100%; z-index: 10000; top: 0; left: 0; position: fixed;">
    <v-progress-linear color="white" height="5" indeterminate />
  </div>
</template>

<script>
    export default {
        name: 'loading',
        props: {
          show: { type: Boolean }
        }
    }
</script>

<style scoped>

</style>
